import styled, { css } from 'styled-components';

import { rem } from 'approot/shared/style';
import {
  spacing12,
  spacing16,
  spacing24,
  spacing4,
  spacing8,
} from 'approot/shared/styles/spacing.style';
import { borderRadius8 } from 'approot/shared/styles/borders.style';
import { grey1, grey4 } from 'approot/shared/styles/colours.style';
import { useActivityBuilderFontStyles } from 'approot/activity-builder/theme/activity-builder-theme.style';
import {
  FONT_CALIBRE_SCHOOL,
  fontSize14,
  fontWeightMedium,
} from 'approot/shared/styles/typography.style';
import { ColourItem } from 'approot/shared/colour/colour-token.style';

type FillInBlanksPunctuationProps = {
  $punctuation: string | null;
};
export const FillInBlanksPunctuationCss = css<FillInBlanksPunctuationProps>`
  ${({ $punctuation }) =>
    $punctuation &&
    $punctuation === '?' &&
    `
    margin-right: ${rem(spacing16)};

    &:before {
      content: '${$punctuation}';
      position: absolute;
      right: -${rem(spacing16)};
    }
  `};

  ${({ $punctuation }) =>
    $punctuation &&
    ($punctuation === '!' || $punctuation === ':' || $punctuation === ';') &&
    `
    &:before {
      content: '${$punctuation}';
      position: absolute;
      right: -${rem(spacing8)};
    }
  `};

  ${({ $punctuation }) =>
    $punctuation &&
    ($punctuation === '.' || $punctuation === ',') &&
    `
    &:before {
      content: '${$punctuation}';
      position: absolute;
      right: -${rem(spacing8)};
      bottom: -${rem(spacing8)};
    }
  `};

  ${({ $punctuation }) =>
    $punctuation === '"' &&
    `
    margin-left: ${rem(spacing12)};

    &:before {
      content: '“';
      position: absolute;
      left: -${rem(10)};
      top: -${rem(spacing8)};
    }
    &:after {
      content: '”';
      position: absolute;
      right: -${rem(10)};
      top: -${rem(spacing8)};
    }
  `};
`;

type FillInBlanksLabelSupportProps = {
  $label: string | null;
  $colours: ColourItem;
};
export const FillInBlanksLabelSupport = css<FillInBlanksLabelSupportProps>`
  ${({ $label, $colours }) =>
    $label &&
    `
    &:after {
      content: '${$label}';
      color: ${$colours.base};
      display: inline-block;
      font-family: ${FONT_CALIBRE_SCHOOL};
      font-size: ${rem(fontSize14)};
      font-weight: ${fontWeightMedium};
      position: absolute;
      left: 0;
      top: -${rem(spacing16)};
      line-height: ${rem(spacing16)};
      z-index: 2;
      white-space: nowrap;
    }
  `};
`;

type FillInBlanksSentencesWrapperProps = {
  $fontFamily: string;
};
export const FillInBlanksSentencesWrapper = styled.div<
  FillInBlanksSentencesWrapperProps
>`
  background-color: ${grey1};
  border-radius: ${rem(borderRadius8)};
  border: 1px solid ${grey4};
  padding: ${rem(spacing12)} 0;
  width: 100%;

  ${({ $fontFamily }) =>
    $fontFamily &&
    `
      font-family: ${$fontFamily};
      p {
        font-family: ${$fontFamily};
      }
    `}
`;

export const FillInBlanksSentence = styled.div`
  padding: ${rem(spacing4)} ${rem(spacing24)};
  position: relative;

  & > div:first-child {
    margin-left: 0;
  }
`;

export const FillInBlanksTextBlock = styled.div`
  ${() => useActivityBuilderFontStyles()}
  margin: 0 ${rem(spacing8)};
  display: inline;
  p, span {
    display: inline;
  }
`;
